module.exports = __webpack_public_path__ + "static/media/bell.5863f9f6.png";